var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75H5H5.56448L5.72071 4.29244L6.28448 6.25H19.445C20.23 6.25 20.7842 7.019 20.536 7.76366L18.7115 13.2372L18.5406 13.75H18H8.1113L8.5913 15.75H17.5C17.9142 15.75 18.25 16.0858 18.25 16.5C18.25 16.9142 17.9142 17.25 17.5 17.25H8H7.4087L7.27071 16.675L6.43071 13.175L4.99464 7.19139L4.43552 5.25H3C2.58579 5.25 2.25 4.91421 2.25 4.5ZM6.6713 7.75L7.7513 12.25H17.4594L18.9594 7.75H6.6713ZM10 19.5C10 20.0523 9.55228 20.5 9 20.5C8.44772 20.5 8 20.0523 8 19.5C8 18.9477 8.44772 18.5 9 18.5C9.55228 18.5 10 18.9477 10 19.5ZM16.5 20.5C17.0523 20.5 17.5 20.0523 17.5 19.5C17.5 18.9477 17.0523 18.5 16.5 18.5C15.9477 18.5 15.5 18.9477 15.5 19.5C15.5 20.0523 15.9477 20.5 16.5 20.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.f3e73595.svg";
export { ForwardRef as ReactComponent };